exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-script {\n  margin-top: 12px;\n  font-size: 1rem;\n  font-weight: 600;\n}\n", ""]);

// exports
